export const PAYOUT_CONVERSION_FORM_LINK =
  'https://docs.google.com/forms/d/e/1FAIpQLSd8MRu5TcSG5G-R4D_yBs3wu87YRbKhgg7mHsBQ2FFjUsF_lg/viewform?usp=dialog';

export const QUERY_LIMIT = 4;
